<template>
    <div>
        <CommonHeader/>
<!--        <div style="background: #6A9FF9;padding: 20px 0">-->
<!--            <div class="container">-->
<!--                <a-row type="flex" justify="space-around" align="middle">-->
<!--                    <a-col :span="10">-->
<!--                        <h1 class="color-white">帮助中心</h1>-->
<!--                        <a-input-search placeholder="搜索常见帮助问题" size="large">-->
<!--                            <a-button slot="enterButton">-->
<!--                                <a-icon type="search" />-->
<!--                            </a-button>-->
<!--                        </a-input-search>-->
<!--                    </a-col>-->
<!--                    <a-col :span="14">-->
<!--                        <img style="margin-left: auto" src="../../img/p2.png">-->
<!--                    </a-col>-->
<!--                </a-row>-->
<!--            </div>-->
<!--        </div>-->
        <div class="container" style="margin-top: 20px;box-shadow: rgba(0, 0, 0, 0.2) 0 2px 10px;min-height: calc(100vh - 56px - 108px);background: #fff">
            <div class="bg-white">
                <a-row>
                    <a-col :span="24">
                        <a-card>
                            <a-breadcrumb class="border-bottom pb-5">
                                <a-breadcrumb-item><a href="javascript:;" @click="findPass">帮助中心</a></a-breadcrumb-item>
                                <a-breadcrumb-item>账号管理</a-breadcrumb-item>
                            </a-breadcrumb>
                            <a-tabs class="mt-5" :default-active-key="qqq" tabPosition="left">
                                <a-tab-pane key="1" tab="注册账号">
                                    <h1>注册账号</h1>
                                    <a-steps direction="vertical" size="default">
                                        <a-step>
                                            <div class="bold" slot="title">首先进入志正快速采购平台首页界面，点击“去注册”</div>
                                            <span slot="description">
                                                <img src="../../img/help/z1.png">
                                            </span>
                                        </a-step>
                                        <a-step>
                                            <div class="bold" slot="title">选择对应的身份注册账号</div>
                                            <span slot="description">
                                                <img src="../../img/help/z2.png">
                                            </span>
                                        </a-step>
                                    </a-steps>
                                </a-tab-pane>
                                <a-tab-pane key="2" tab="如何登陆">
                                    <h1>如何登陆</h1>
                                    <a-steps direction="vertical" size="default">
                                        <a-step>
                                            <div class="bold" slot="title">首页供应商登录的入口如下图所示：</div>
                                            <span slot="description">
                                                <img src="../../img/help/z3.png">
                                            </span>
                                        </a-step>
                                        <a-step>
                                            <div class="bold" slot="title">进入登录页面选择供应商登录，输入账号(手机、身份证号码)后登录即可。</div>
                                            <span slot="description">
                                                <img src="../../img/help/z4.png">
                                            </span>
                                        </a-step>
                                    </a-steps>
                                </a-tab-pane>
                                <a-tab-pane key="3" tab="单位认证/变更">
                                    <h1>单位认证/变更</h1>
                                    <a-steps direction="vertical" size="default">
                                        <a-step>
                                            <div class="bold" slot="title">点击如下图中企业认证提交信息审核，单位、企业信息审核通过后才能参与采购项目</div>
                                            <span slot="description">
                                                <img src="../../img/help/z5.png">
                                            </span>
                                        </a-step>
                                        <a-step>
                                            <div class="bold" slot="title">正确填写单位名称和统一信用代码后，点击下一步。</div>
                                            <span slot="description">
                                                <img src="../../img/help/z6.png">
                                            </span>
                                        </a-step>
                                        <a-step>
                                            <div class="bold" slot="title">企业单位详细信息，上传已盖公章的营业执照扫描件”</div>
                                            <span slot="description">
                                                <img src="../../img/help/z7.png">
                                            </span>
                                        </a-step>
                                        <a-step>
                                            <div class="bold" slot="title">企业单位信息提交给代理机构审核，首页左上方会有“审核中”字样提示</div>
                                            <span slot="description">
                                                <img src="../../img/help/z8.png">
                                            </span>
                                        </a-step>
                                        <a-step>
                                            <div class="bold" slot="title">企业单位信息变更信息变更需要提交资料重新审核，审核通过后会更新信息</div>
                                            <span slot="description">
                                                <img src="../../img/help/z14.png">
                                            </span>
                                        </a-step>
                                    </a-steps>
                                </a-tab-pane>
                                <a-tab-pane key="4" tab="绑定/解绑单位">
                                    <h1>绑定/解绑单位</h1>
                                    <a-steps direction="vertical" size="default">
                                        <a-step>
                                            <div class="bold" slot="title">绑定关联企业单位</div>
                                            <span slot="description">
                                                <img src="../../img/help/z15.png">
                                            </span>
                                        </a-step>
                                        <a-step>
                                            <div class="bold" slot="title">输入要关联的企业单位名称、统一信用代码</div>
                                            <span slot="description">
                                                <img src="../../img/help/z16.png">
                                            </span>
                                        </a-step>
                                        <a-step>
                                            <div class="bold" slot="title">关联该企业</div>
                                            <span slot="description">
                                                <img src="../../img/help/z17.png">
                                            </span>
                                        </a-step>
                                        <a-step>
                                            <div class="bold" slot="title">输入管理员手机号，获取管理员手机验证码，点击确认校验正确后关联成功</div>
                                            <span slot="description">
                                                <img src="../../img/help/z11.png">
                                            </span>
                                        </a-step>
                                        <a-step>
                                            <div class="bold" slot="title">关联“企业单位”成功后，自己的信息会显示在“子账号管理”模块中；如下图</div>
                                            <span slot="description">
                                                <img src="../../img/help/z18.png">
                                            </span>
                                        </a-step>
                                        <a-step>
                                            <div class="bold" slot="title">解除绑定企业单位</div>
                                            <span slot="description">
                                                <img src="../../img/help/z19.png">
                                            </span>
                                        </a-step>
                                    </a-steps>
                                </a-tab-pane>
                                <a-tab-pane key="5" tab="子账号管理">
                                    <h1>子账号管理</h1>
                                    <a-steps direction="vertical" size="default">
                                        <a-step>
                                            <div class="bold" slot="title">在账号管理，点击下方的新增子账号按钮（注：企业管理员才可新增子账号）</div>
                                            <span slot="description">
                                                <img src="../../img/help/p7.png">
                                            </span>
                                        </a-step>
                                    </a-steps>
                                </a-tab-pane>
                            </a-tabs>
<!--                            <div style="margin-left: 170px">-->
<!--                                <h2 class="mt-5">仍需要其他帮助？</h2>-->
<!--                                <div class="division"></div>-->
<!--                                <ul class="t2">-->
<!--                                    <li>电话：020-58797485</li>-->
<!--                                </ul>-->
<!--                            </div>-->

                        </a-card>
                    </a-col>
                </a-row>
            </div>

        </div>

        <CommonFooter/>
    </div>
</template>

<script>
    import CommonHeader from '../common/CommonHeader'
    import CommonFooter from '../common/CommonFooter'

    export default {
        components: {
            CommonHeader,
            CommonFooter
        },
        data () {
            return {
                qqq: this.$route.query.id
            }
        },
        methods: {
          findPass() {
            this.$router.push({path:'/message/SysHelp'})
          }
        }
    }
</script>

<style scoped>
    .t1{
        list-style: none;
        font-size: 0;
        padding: 15px 0;
    }
    .t1 li{
        width: 25%;
        display: inline-block;
        margin: 15px 0;
    }
    .t1 li a{
        display: flex;
        align-items: center;
        font-size: 18px;
        color: #262626;
    }
    .t1 li a:hover{
        color: #2f7fe3;
    }
    .t1 li a img{
        margin-right: 8px;
    }

    .t2{
        list-style: none;
        font-size: 0;
        padding: 15px 0;
    }
    .t2 li{
        width: 23%;
        display: inline-block;
        background: #f7f7f7;
        font-size: 16px;
        padding: 12px;
        color: #000;
        margin-left: 2.66666666%;
        margin-top: 15px;
        margin-bottom: 15px;
    }
    .t2 li:nth-child(4n-3){
        margin-left: 0;
    }
    .ant-card-bordered{
        border: none;
    }
    /deep/ .ant-steps-item-wait > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title{
        color: #000;
    }
    /deep/ .ant-steps-item-wait > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-description{
        color: rgba(0, 0, 0, 0.65);
    }
    /deep/ .ant-steps-item-wait .ant-steps-item-icon > .ant-steps-icon{
        color: #fff;
    }
    /deep/ .ant-steps-item-wait .ant-steps-item-icon {
        background-color: rgb(24, 144, 255);
        border-color: rgb(24, 144, 255);
    }
    .ant-steps-item-description img{
        box-shadow: rgba(0, 0, 0, 0.2) 0 3px 9px;
        width: 830px;
        margin: 30px auto
    }
</style>
